import * as React from "react";
import MuiMenuList from "@mui/material/MenuList";
import PropTypes from "prop-types";

const MenuList = (props) => {
  return <MuiMenuList {...props} />;
};

MenuList.propTypes = {
  children: PropTypes.node,
};

export default MenuList;
